module.exports = __webpack_public_path__ + "b730600922d726707fdeaae17018d774.svg";